///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input } from '@angular/core';

@Component({
    selector: 'kb-tab-strip',
    templateUrl: './tab-strip.component.html',
})
export class KbTabStripComponent {
    @Input()
    public id: string;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/tab-strip/tab-strip.component.ts